/*global VeloxWebView*/
var ControllerWithImage = require("../../util/ControllerWithImage") ;

/**
 * This is a basic MVC grid/form controller
 * 
 * It creates 2 routes : #device/list and #device/form
 */
var deviceController = new ControllerWithImage("device", {
    grid : {
        directory: "views/device",
        name: "deviceGrid",
    },
    form : {
        directory: "views/device",
        name: "deviceForm",
        joinFetch: [
            {otherTable: "link_part_device>part", type:"2many", name: "parts", orderBy: "p_ref" }
        ]
    }
});

deviceController.formController.onAddRemoveParts = function(){
    //open popup
    this.view.longTask(function(done){
        this.api.api.multiread({
            part : { search: {}, orderBy: "p_ref" }
        }, done);
    }.bind(this), function(err, reads){
        if(err){ return ;}

        reads.part.forEach(function(p){
            if(p.p_name && p.p_name.length > 25){
                p.p_name = p.p_name.substring(0,25)+"..." ;
            }
        }) ;

        var dataPopup = {
            available: reads.part.filter(function(p){
                return !this.data.parts.some(function(s){ return s.p_ref === p.p_ref ;}) ;
            }.bind(this)),
            selected: this.data.parts
        } ;

        var viewAddRemove = new VeloxWebView("views/part", "popupAddRemove", {bindObject: dataPopup}) ;
        viewAddRemove.openInPopup({
            size:"large",
            title: VeloxWebView.tr("device.addRemoveParts")
        })  ;
    
        /**
         * User validate creation of a new user
         */
        viewAddRemove.on("validate",function(){
            viewAddRemove.updateData() ;
            viewAddRemove.close() ;
            
            var changes = [] ;
            changes.push({table: "link_part_device", action: "removeWhere", record:{d_ref : this.data.d_ref}}) ;
            dataPopup.selected.forEach(function(p){
                changes.push({table: "link_part_device", action: "insert", record: {d_ref: this.data.d_ref, p_ref: p.p_ref}}) ;
            }.bind(this)) ;

            this.view.longTask(function(done){
                this.api.api.transactionalChanges(changes, function(err){
                    if(err){ return done(err) ;}
                    this.refresh() ;
                    done() ;
                }.bind(this)) ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;

module.exports = deviceController ;